import { useNavigate } from "react-router-dom"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import { MERCHANT_ADMIN_ROUTE, MESSAGES_ROUTE } from "../../../../../constants/routes"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { CreateUpdateMessageForm } from "../components/CreateUpdateMessageForm"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { useCreateMessageFlow } from "../components/messagesHooks"

export function CreateMessage() {
    const navigate = useNavigate()

    const { formRef, handleSaveClick, handleSubmit } = useCreateMessageFlow(() => navigate(MESSAGES_ROUTE))

    return (
        <>
            <LocalizedStrict id="create-message-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MESSAGE_CREATE}
                    title="Create message"
                    rightElement={
                        <LocalizedStrict id="create-message-save-button">
                            <StandardButton type="submit" onClick={handleSaveClick}>
                                Create
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-messages">
                            <BreadcrumbLink to={MESSAGES_ROUTE}>Push messages</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="nav-item-create-message-header">
                            <Breadcrumb>Create message</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <CreateUpdateMessageForm ref={formRef} mode="create" onSubmit={handleSubmit} />
        </>
    )
}
